// define a mixin object

/**
 * @type {{created: FormFieldMixin.created, methods: {emitGlobalFieldChangeEvent(): void}}}
 *
 *
 *
 *
 *
 * To Listen to all Children Form Field Changes add the following to the mounted method on the grandparent component
 *
 mounted() {
      // This listens to the Global Input Emitter for all children.
      // So if an input is changed we can mark this section as Dirty.
      this.$el.addEventListener("global-input", () => {
        console.log('Global Event Listener is working');
        this.pageIsDirty = true;
      }, true)
    },
 */
export let FormFieldMixin = {
  created: function () {
  },
  methods: {
    emitGlobalFieldChangeEvent() {
      try {
        this.$el.dispatchEvent(new Event("global-input"));
      } catch (e) {
        console.error(e);
        // handle IE not supporting Event constructor
        var evt = document.createEvent("Event");
        evt.initEvent("global-input", true, false);
        this.$el.dispatchEvent(evt);
      }
    },
  },
}

